import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Input, DatePicker, Select, Button, Row, Col, message } from 'hljd'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import store from './store'
import myStore from '../store'
import { now } from '@hlj/hlj-utils'

const Item = Form.Item
const Option = Select.Option
const RangePicker = DatePicker.RangePicker
@observer
export default class extends Component {
  componentDidMount() {
    store.getList(1)
  }
  handleSetPhone = e => {
    store.setPhone(e.target.value)
  }
  handleSetUserName = e => {
    store.setUserName(e.target.value)
  }
  handleSetDate = value => {
    if (value[0]) {
      if (value[0].format('YYYY-MM-DD') >= now().format('YYYY-MM-DD')) {
        store.setDate(value)
      } else {
        message.warning('开始日期不能选择已过期的日期')
      }
    } else {
      store.setDate([])
    }
  }
  handleSetMealRoom = value => {
    store.setMealRoom(value)
  }
  handleSetMeals = value => {
    store.setMeals(value)
  }
  handleSearch = () => {
    store.search()
  }
  handleRest = () => {
    store.reset()
  }
  render() {
    const { phone, user_name, date, entity_id, time_str } = store
    const { hotelHalls } = myStore
    let allHotelHalls = (hotelHalls || []).map(item => (
      <Option value={item.id} key={item.id}>
        {item.name}
      </Option>
    ))
    return (
      <Form
        layout="inline"
        style={{
          padding: '20px 20px 20px 0',
          border: '1px solid #e7e7e7',
          marginTop: 20
        }}
      >
        <Row style={{ marginBottom: 20 }}>
          <Col span={6} style={{ textAlign: 'right' }}>
            <Item label="客户手机">
              <Input
                style={{ width: 120 }}
                value={phone}
                onChange={this.handleSetPhone}
              />
            </Item>
          </Col>
          <Col span={6} style={{ textAlign: 'right' }}>
            <Item label="客户姓名">
              <Input
                style={{ width: 120 }}
                value={user_name}
                onChange={this.handleSetUserName}
              />
            </Item>
          </Col>
          <Col span={12} style={{ textAlign: 'right' }}>
            <Item label="档期">
              <RangePicker
                style={{ width: 335, textAlign: 'left' }}
                onChange={this.handleSetDate}
                value={toJS(date)}
              />
            </Item>
          </Col>
        </Row>
        <Row>
          <Col span={6} style={{ textAlign: 'right' }}>
            <Item label="宴会厅">
              <Select
                style={{ width: 120, textAlign: 'left' }}
                value={entity_id}
                onChange={this.handleSetMealRoom}
              >
                <Option value={''}>全部</Option>
                {allHotelHalls}
              </Select>
            </Item>
          </Col>
          <Col span={6} style={{ textAlign: 'right' }}>
            <Item label="市别">
              <Select
                style={{ width: 120, textAlign: 'left' }}
                value={time_str}
                onChange={this.handleSetMeals}
              >
                <Option value={''}>全部</Option>
                <Option value={'1'}>午市</Option>
                <Option value={'2'}>晚市</Option>
              </Select>
            </Item>
          </Col>
          <Col span={12} style={{ textAlign: 'right' }}>
            <Item style={{ margin: '0 20px 0 20px' }}>
              <Button
                style={{ width: 80 }}
                type="primary"
                onClick={this.handleSearch}
              >
                查询
              </Button>
              <Button
                style={{ marginLeft: 14, width: 80 }}
                onClick={this.handleRest}
              >
                重置
              </Button>
            </Item>
          </Col>
        </Row>
      </Form>
    )
  }
}
